import { isProductionEnvironment } from './env-utils.ts'

// These PostHog values are public (they ship in the bundle either way) and are the only values
// that differ between environments. Selecting at runtime keeps the build environment-independent,
// so the exact artifact validated on staging is what gets promoted to production.
const PRODUCTION_PROJECT = {
  apiKey: 'phc_HTN1khgMX63Uj2Lh3OhvXTcnj8pPExaqPFyWzkYuLKP',
  brokerQuoteCreationSurveyId: '019c6abe-c5c1-0000-eb64-5f7547123683',
}

const DEVELOPMENT_PROJECT = {
  apiKey: 'phc_fqGrpsHsc3wXyFuDLhtQhp6fsN8yDdYXM1bqyCGqYkz',
  brokerQuoteCreationSurveyId: '019c9091-73c8-0000-641d-fb46e1ad8b84',
}

export function getPostHogProject(): typeof PRODUCTION_PROJECT {
  return isProductionEnvironment() ? PRODUCTION_PROJECT : DEVELOPMENT_PROJECT
}
